import { Extension } from "main.core";
import * as Sentry from "@sentry/browser";
import { BrowserTracing } from "@sentry/tracing";
import { CaptureConsole as CaptureConsoleIntegration } from "@sentry/integrations";

const settings = Extension.getSettings('citrus.sentry');

Sentry.init({
	dsn: settings.dsn,
	environment: settings.env,
	integrations: [
		new BrowserTracing(),
		new CaptureConsoleIntegration({
			levels: ['error', 'warning'],
		}),

	],

	// Set tracesSampleRate to 1.0 to capture 100%
	// of transactions for performance monitoring.
	// We recommend adjusting this value in production
	tracesSampleRate: settings.tracesSampleRate,

});
